(function () {
  'use strict';

  var locationIds = new Set(['san-pedro-nl', 'jax-moto-lab-leon']);
  var contactMethods = new Set(['phone', 'whatsapp', 'form', 'maps', 'location_details']);
  var handledLeadForms = new WeakSet();
  var leadSubmissionStorageKey = 'jax-lead-submission';

  function getAnalyticsApi() {
    var shopify = window.Shopify;
    var privacy = shopify && shopify.customerPrivacy;

    if (
      !shopify ||
      !shopify.analytics ||
      typeof shopify.analytics.publish !== 'function' ||
      !privacy ||
      typeof privacy.analyticsProcessingAllowed !== 'function' ||
      !privacy.analyticsProcessingAllowed()
    ) {
      return null;
    }

    return shopify.analytics;
  }

  function publish(name, data, analyticsApi) {
    var analytics = analyticsApi || getAnalyticsApi();

    if (!analytics) return false;

    try {
      var result = analytics.publish(name, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (error) {
      return false;
    }
  }

  function getLocationId(element) {
    var value = element && element.dataset && element.dataset.locationId;
    return locationIds.has(value) ? value : null;
  }

  function getSessionStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function readLeadSubmission(storage) {
    try {
      var value = JSON.parse(storage.getItem(leadSubmissionStorageKey) || 'null');
      if (
        value &&
        locationIds.has(value.code) &&
        typeof value.nonce === 'string' &&
        value.nonce.length > 0 &&
        typeof value.sent === 'boolean'
      ) {
        return value;
      }
    } catch (error) {
      // Ignore stale or inaccessible session data.
    }

    return null;
  }

  function storeLeadSubmission(event) {
    var form = event.target;
    if (!form || !form.dataset || form.dataset.jaxContactForm !== 'true') return;

    var storage = getSessionStorage();
    if (!storage) return;

    var locationId = getLocationId(form);

    try {
      if (!locationId) {
        storage.removeItem(leadSubmissionStorageKey);
        return;
      }

      storage.setItem(leadSubmissionStorageKey, JSON.stringify({
        code: locationId,
        nonce: Date.now().toString(36) + '-' + Math.random().toString(36).slice(2),
        sent: false,
      }));
    } catch (error) {
      // Storage can be disabled by browser privacy settings.
    }
  }

  function isJaxSuccessMarker(element) {
    if (!element) return false;

    if (
      typeof element.matches === 'function' &&
      element.matches('form[data-jax-contact-form="true"][data-jax-lead-success]')
    ) {
      return true;
    }

    if (typeof element.closest !== 'function') return false;
    return Boolean(element.closest('form[data-jax-contact-form="true"]'));
  }

  function getSuccessfulFormLocationId(marker) {
    var locationId = getLocationId(marker);
    var form = marker && typeof marker.closest === 'function'
      ? marker.closest('form[data-jax-contact-form="true"]')
      : null;

    if (!locationId) locationId = getLocationId(form);
    return locationId;
  }

  function trackContactClick(event) {
    var target = event.target;
    var link = target && typeof target.closest === 'function'
      ? target.closest('[data-location-id][data-contact-method]')
      : null;
    var locationId = getLocationId(link);
    var contactMethod = link && link.dataset && link.dataset.contactMethod;

    if (!locationId || !contactMethods.has(contactMethod)) return;

    publish('jax_contact_click', {
      location_id: locationId,
      contact_method: contactMethod,
    });
  }

  function trackSuccessfulForms() {
    var markers = document.querySelectorAll('[data-jax-lead-success]');
    var storage = getSessionStorage();
    if (!storage) return;

    var submission = readLeadSubmission(storage);
    if (!submission || submission.sent) return;

    markers.forEach(function (marker) {
      if (handledLeadForms.has(marker) || !isJaxSuccessMarker(marker)) return;

      var markerLocationId = getSuccessfulFormLocationId(marker);
      if (markerLocationId && markerLocationId !== submission.code) return;

      var analytics = getAnalyticsApi();
      if (!analytics) return;

      submission.sent = true;
      try {
        storage.setItem(leadSubmissionStorageKey, JSON.stringify(submission));
      } catch (error) {
        submission.sent = false;
        return;
      }

      var sent = publish('generate_lead', {
        location_id: markerLocationId || submission.code,
        contact_method: 'form',
      }, analytics);

      if (sent) {
        handledLeadForms.add(marker);
      } else {
        submission.sent = false;
        try {
          storage.setItem(leadSubmissionStorageKey, JSON.stringify(submission));
        } catch (error) {
          // Keep the attempted state if storage is no longer writable.
        }
      }
    });
  }

  document.addEventListener('click', trackContactClick);
  document.addEventListener('submit', storeLeadSubmission);
  document.addEventListener('visitorConsentCollected', trackSuccessfulForms);

  trackSuccessfulForms();

  if (typeof window.MutationObserver === 'function' && document.documentElement) {
    var observer = new window.MutationObserver(trackSuccessfulForms);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
